(() => {
  function trackCheckout(link) {
    const root = link.closest('.cdp-lp');
    if (!root || typeof window.fbq !== 'function') return;
    const name = root.querySelector('.cdp-checkout > p')?.textContent?.trim() || document.title;
    const priceText = root.querySelector('.cdp-checkout__price')?.textContent || '0';
    const value = Number(priceText.replace(/[^0-9,]/g, '').replace(',', '.')) || 0;
    window.fbq('track', 'InitiateCheckout', { content_name: name, content_type: 'product', value, currency: 'BRL' });
  }
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-cdp-checkout]');
    if (link) trackCheckout(link);
  });
})();
